import React, { useEffect, useState } from "react";
import InnerLayout from "../../components/layouts/inner-layout";
import AdminCusCreateEditView from "../../components/admin-customer/admin-cus-create-edit-view";
import { useDispatch } from "react-redux";
import { adminCustomerViewAction } from "../../redux/actions/admin-customer-action";
import { useParams } from "react-router-dom";
import LoadingSpinner from "../../components/helper-components/loading-spinner";
import AdminCusCreateEditViewn from "../../components/admin-customer/admin-cus-create-edit-viewn";
import { useLocation } from "react-router-dom";

const AdminEditCustomer = () => {
  const [reload, setReload] = useState(false);
  const { id } = useParams();
  const [loading, setLoading] = useState(true);
  const [customerId, setCustomerId] = useState(null);
  const dispatch = useDispatch();
  const [customerDetails, setCustomerDetails] = useState({});
  const location = useLocation();
  const { tab } = location.state || {}; // tab will be "Address"
  useEffect(() => {
    dispatch(adminCustomerViewAction(id, onSuccess, onError));
  }, [reload]);
  useEffect(() => {
    localStorage.removeItem("customerAdmin");
  }, []);
  const onSuccess = (data) => {
    setLoading(false);
    setCustomerId(data?.data?.general?.cmr_id);
    setCustomerDetails(data?.data);
  };
  const onError = (data) => {
    console.log(data);
  };

  return (
    <>
      {loading ? (
        <LoadingSpinner />
      ) : (
        <InnerLayout
          backBtn={true}
          onclkFn={"/admin/add-customer"}
          title="Update Party"
        >
          <AdminCusCreateEditViewn
            page="edit"
            cmrId={customerId}
            // setCustomerId={setCustomerId}
            reload={reload}
            setReload={setReload}
            customerDetails={customerDetails}
            //
            initialData={customerDetails}
            disabled={false}
            tab={tab}
          />
        </InnerLayout>
      )}
    </>
  );
};

export default AdminEditCustomer;
